import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';

// Components
import Meta from '../../shared/Meta';
import TermsText from '../../shared/TermsText';

import styles from '../../../../stylesheets/public/layouts/AboutPage.module.postcss';

function Terms() {
  const { site_title } = useContext(ConfigContext);

  return (
    <div>
      <Meta
        title={`Terms & Conditions - ${site_title}`}
        breadcrumbName='Terms & Conditions'
      />
      <h2 className={styles.PrivacyPage_header}>Terms & Conditions</h2>
      <TermsText className={styles.AboutPage_body} />
    </div>
  );
}

export default Terms;
